import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { colors } from "@mui/material";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Reach out to us</h3>
          <p>
            <span role="img" aria-label="Phone">📞</span>+91 9811133790
          </p>
          <p>
            <span role="img" aria-label="Email">📧</span> contact@etechnoedu.org
          </p>
          <p>
            <span role="img" aria-label="Location">📍</span> India
          </p>
        </div>
        <div className="footer-section">
          <h3>Company</h3>
          <Link to="/about-us">
            <p>About</p>
          </Link>
          <Link to="/contact-us">
            <p>Contact</p>
          </Link>
          <Link to="/success">
            <p>Success</p>
          </Link>
        </div>
        <div className="footer-section">
          <h3>Legal</h3>
          <Link to="/privacy-policy">
            <p>Privacy Policy</p>
          </Link>
          <Link to="/terms-service">
            <p>Terms & Services</p>
          </Link>
          <Link to="/terms-of-use">
            <p>Terms of Use</p>
          </Link>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <Link to="/donate-form">
            <p>Donate Now</p>
          </Link>
          <Link to="/membership">
            <p>Membership</p>
          </Link>
          <Link to="/our-mission">
            <p>Our Mission</p>
          </Link>
        </div>
        <div className="footer-section newsletter">
          <h3>Join Our Newsletter</h3>
          <form>
            <input type="email"  className="newsletter-input" placeholder="Your email address" />
            <button type="submit">Subscribe</button>
          </form>
          <p className="newsletter-text">
            * Will send you weekly updates for you to stay in touch with our progress.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;